import { FC } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import MainMenu from './MainMenu';
const MainMenuLogic: FC = () => {
  const {
    mainMenu,
    isGinARaiDeeMenuOpen,
    isNewsOpen,
    setIsNewsOpen,
    setIsGinARaiDeeMenuOpen,
    setIsHamburgerOpen,
    setIsProfilePopupOpen,
    setIsSearchModalOpen
  } = headerStore(state => state);
  const closeAllModal = () => {
    setIsNewsOpen(false);
    setIsGinARaiDeeMenuOpen(false);
    setIsHamburgerOpen(false);
    setIsProfilePopupOpen(false);
    setIsSearchModalOpen(false);
  };
  return <MainMenu mainMenu={mainMenu} isGinARaiDeeOpen={isGinARaiDeeMenuOpen} setIsGinARaiDeeOpen={setIsGinARaiDeeMenuOpen} isNewsOpen={isNewsOpen} setIsNewOpen={() => setIsNewsOpen(!isNewsOpen)} closeAllModal={closeAllModal} />;
};
export default MainMenuLogic;